/**
 * WPN GATEWAY ENTERPRISE WEB ADMIN API' dev
 *
 * API version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { BranchCostAppraisalProductResponseDto } from './branchCostAppraisalProductResponseDto';

export interface BranchCostAppraisalResponseDto {
  createdUserId: string;
  createdUsername: string;
  createdAt: Date;
  updatedUserId: string;
  updatedUsername: string;
  updatedAt: Date;
  deletedUserId: string;
  deletedUsername: string;
  deletedAt: Date;
  id: string;
  /**
   * 2021-10-01T00:00:00Z
   */
  effectiveDate: string;
  status: BranchCostAppraisalResponseDto.StatusEnum;
  branchCostAppraisalProducts: Array<BranchCostAppraisalProductResponseDto>;
}
// tslint:disable-next-line:no-namespace
export namespace BranchCostAppraisalResponseDto {
  export type StatusEnum = 'draft' | 'active' | 'in_active';
  export const StatusEnum = {
      Draft: 'draft' as StatusEnum,
      Active: 'active' as StatusEnum,
      InActive: 'in_active' as StatusEnum,
  };
}
